import React from "react";
import { cn } from "@/lib/utils";
import logo from "@/assets/brand-logo.png";

/** Official Inner Compass brand mark.
 *  - Uses one shared asset (import from src/assets, so webpack fingerprints & caches).
 *  - Preserves transparency, never stretches, always crisp on high-DPI (real bitmap scaled down + object-contain).
 *  - Sizing kept between the requested 36–48px range via presets. */
const SIZES = {
  xs: "h-6 w-6",       // 24px — very small chips
  sm: "h-9 w-9",       // 36px — mobile header
  md: "h-10 w-10",     // 40px — compact desktop
  lg: "h-11 w-11",     // 44px — desktop default (in-spec)
  xl: "h-12 w-12",     // 48px — auth screens (in-spec)
  "2xl": "h-16 w-16",  // 64px — hero/loader
  "3xl": "h-20 w-20",  // 80px — splash
};

export default function BrandLogo({
  size = "lg",
  className,
  alt = "Inner Compass",
  rounded = "rounded-2xl",
  loading = "eager",
  ...rest
}) {
  const cls = SIZES[size] || SIZES.lg;
  return (
    <img
      src={logo}
      alt={alt}
      loading={loading}
      decoding="async"
      draggable={false}
      className={cn(cls, rounded, "object-contain select-none", className)}
      {...rest}
    />
  );
}
